import type { ComponentType, ReactNode } from 'react';
import { Suspense, lazy } from 'react';

import { Loader } from '@mantine/core';

/* eslint-disable react/function-component-definition */
export default function LazyLoader<P extends object>(
  dynamicComponent: () => Promise<{ default: ComponentType<P> }>,
  customLoader: ReactNode = undefined,
) {
  const LazyComponent = lazy(dynamicComponent) as unknown as ComponentType<P>;

  return function LazyLoaded(props: P) {
    return (
      <Suspense fallback={customLoader !== undefined ? customLoader : <Loader />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
}
